module.exports = __webpack_public_path__ + "static/Aptible-b970260a35d330980a196ea102e52ad5.jpg";